

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'
import productsModule from '@/store/products'
import momentoGanadorModule from '@/store/momento-ganador'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import appinfo from '../../package.json';

import {langdetector} from '@/langdetector';

let lang = langdetector();


export const store = new Vuex.Store({
  state :{
    language: lang || 'es',
    server : 'https://back.fiesta.es/',
    packageVersion : appinfo.version,
    animations : true
  },
  actions :{
    changeLanguage : ({commit,dispatch}, nextLang) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
        dispatch('initApp')
      });
    },
    eraseAnimations : ({commit}) => {
      commit("eraseAnimations")
    },
    initApp({dispatch}){
      dispatch('requestNoticias');
      dispatch('requestPromociones');
      dispatch('requestCategories');
      dispatch('requestNotasPrensa');
      dispatch('requestFaqs');
      dispatch('requestCuriosidades');
    }
  },
  getters : {
    getVersion : state => state.packageVersion,
    getLanguage : state => state.language,
    getServer : state => state.server,
    getAnimations : state => state.animations,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    },
    eraseAnimations(state){
      state.animations = false;
    }
  },
  modules :{
    actualidadModule,
    formulariosModule,
    productsModule,
    momentoGanadorModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js